export default "__VITE_ASSET__UpadcW8tBWqxKusCNme73w__";